import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=566a8384&scoped=true&"
import script from "./AssignModal.vue?vue&type=script&lang=js&"
export * from "./AssignModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignModal.vue?vue&type=style&index=0&id=566a8384&lang=scss&scoped=true&"
import style1 from "./AssignModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a8384",
  null
  
)

export default component.exports